import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

interface Props {
  display?: boolean;
  setDisplay?: any;
  config: {
    actionName: string;
    title: string;
  };
  onCreateInvoice?: any;
  onCreateInvoiceList?: any;
}

export const DialogCreateMultipleInvoiceOptions = ({
  display,
  setDisplay,
  config,
  onCreateInvoice,
  onCreateInvoiceList,
}: Props) => {
  const close = () => setDisplay(false);

  return (
    <Dialog
      header={`Lập hóa đơn ${config.title} Nhiều hóa đơn`}
      visible={display}
      style={{ width: "47rem" }}
      draggable={false}
      resizable={false}
      onHide={close}
    >
      <div className="line-height-3 text-700">
        <div className="mb-3">
          Căn cứ Điểm b.2, Khoản 1, Điều 10 Thông tư 91/2026/TT-BTC:
          Trường hợp trong tháng người bán đã lập sai cùng thông tin về người
          mua, tên hàng, đơn giá, số lượng, thuế suất trên nhiều hóa đơn của
          cùng một người mua trong cùng tháng, thì người bán được lập một hóa
          đơn điều chỉnh hoặc thay thế cho nhiều hóa đơn điện tử đã lập sai
          trong cùng tháng và đính kèm bảng kê các hóa đơn điện tử đã lập sai
          theo Mẫu số 01/BK-ĐCTT
        </div>

        <div
          className="border-round p-3 mb-3"
          style={{ backgroundColor: "#e8f4ff" }}
        >
          <div className="font-bold text-xl mb-3">
            Thao tác tạo hóa đơn {config.actionName} cho nhiều hóa đơn gồm 2
            bước sau:
          </div>
          <div className="mb-3">
            Bước 1: Lập bảng kê chứa danh sách chi tiết hóa đơn sai sót cần{" "}
            {config.title}
          </div>
          <div>
            Bước 2: Tạo hóa đơn {config.actionName} gắn với Số bảng kê, Ngày
            bảng kê đã lập
          </div>
        </div>

        <div>Bạn có muốn lập bảng kê đính kèm không?</div>
      </div>

      <div className="flex justify-content-end align-items-center mt-5 gap-2">
        <Button label="Hủy bỏ" className="p-button-text" onClick={close} />
        <Button
          label="Lập hóa đơn, bỏ qua bước lập bảng kê"
          className="p-button-outlined"
          onClick={() => {
            close();
            onCreateInvoice?.();
          }}
        />
        <Button
          label="Lập bảng kê đính kèm"
          onClick={() => {
            close();
            onCreateInvoiceList?.();
          }}
        />
      </div>
    </Dialog>
  );
};
